import {
  Box,
  Column,
  Columns,
  ContentBlock,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

interface Props {
  heading: React.ReactNode;
  text: React.ReactNode;
  image: string;
}

export const HeroWithImage = ({ heading, text, image }: Props) => (
  <ContentBlock width="large">
    <Box paddingX={['gutter', 'gutter', 'xxlarge']} paddingY="large">
      <Columns space="xlarge" alignY="center" collapseBelow="tablet">
        <Column width="1/2">
          <Stack space="large">
            <Box paddingRight={['none', 'none', 'xlarge']}>
              <Heading level="1">{heading}</Heading>
            </Box>
            <Text size="large">{text}</Text>
          </Stack>
        </Column>
        <Column width="1/2">
          <Box
            borderRadius="large"
            style={{
              width: '100%',
              height: '360px',
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '50%',
            }}
          />
        </Column>
      </Columns>
    </Box>
  </ContentBlock>
);
